import React from "react";

const Spinner = () => {
  const spinnerContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100px",
  };

  const spinnerStyle = {
    width: "120px",
    height: "120px",
    border: "12px solid rgba(255, 255, 255, 0.8)",
    borderTop: "8px solid rgba(0, 0, 0, 0.0)",
    borderRadius: "100%",
    animation: "spin 1s linear infinite",
  };

  return (
    <div style={spinnerContainerStyle}>
      <div style={spinnerStyle}></div>
      <style>
        {`
            @keyframes spin {
                to { transform: rotate(360deg); }
            }
            `}
      </style>
    </div>
  );
};

export default Spinner;